// extracted by mini-css-extract-plugin
export default {"title":"eUA5UD","lockIcon":"vVZyl2"};